<template>
    <section class="HeroBlock" :id=block_id>
        <div class="overflow-hidden bg-white">
            <div class="flex flex-col gap-12 container-hero md:gap-16">

                <!-- Hero Text -->
                <div class="flex flex-col">

                    <!-- Byline -->
                    <span class="mb-1 font-bold tracking-wide uppercase body-sm text-neutral-500 text-balance">{{ byline }}</span>

                    <!-- Hero Title -->
                    <h1 class="mb-4 head-xl xl:head-2xl text-neutral-900 max-w-[16ch] text-balance">{{ headline }}<span class="text-gradient from-secondary-500 to-tertiary-500">{{ headlineAccent }}</span></h1>

                    <!-- Hero Copy -->
                    <p class="mb-8 body-md text-neutral-600 max-w-[55ch] text-balance">{{ copy }}</p>
                    
                    <div class="flex flex-wrap items-baseline gap-y-2 gap-x-6 md:gap-x-8">

                        <!-- Primary CTA -->
                        <a class="btn btn-md btn-filled btn-primary" target="_blank" :href="cta_primary.url">{{ cta_primary.text }}</a>
                        
                        <!-- Secondary CTA -->
                        <a class="btn btn-md btn-link btn-neutral" target="_blank" :href="cta_secondary.url" >{{ cta_secondary.text }}</a>

                    </div>
                </div>
                
                <!-- Hero Images -->
                <div class="flex items-center justify-center gap-8 lg:gap-12">
                    <div v-for="item in hero_pictures" :key="item" class="shrink-0">

                        <picture>
                            <img
                                :alt=item.title
                                :src=preloadedImages[item.index]
                                :class="'object-cover aspect-[3/2] h-40 md:h-48 lg:h-60 transition-all rounded-lg lg:rounded-xl hover:rotate-0 hover:scale-105 saturate-[1.15] ' + item.rotation "
                            >
                        </picture>
                        
                    </div>
                </div>
                
            </div>
        </div>
    </section>
</template>

<script>

    export default {
        
        name: 'HeroBlock',

        props: {
            content: Object, // Hero Content
        },

        data(){
            return {
                block_id: this.content.block_id,
                byline: this.content.byline,
                headline: this.content.headline,
                headlineAccent: this.content.headlineAccent,
                copy: this.content.copy,
                cta_primary: this.content.cta_primary,
                cta_secondary: this.content.cta_secondary,
                hero_pictures: this.content.hero_pictures,
                
                preloadedImages: [],
            }
        },

        mounted() {

            this.content.hero_pictures.forEach((item) => {
                this.preloadImage(item);
            });

        },

        methods: {
            
            preloadImage(item) {
                const image = new Image();
                image.src = item.file[0];
                this.preloadedImages.push(image.src) // Store the preloaded image URL
            },
        },
    }
    
</script>